
import React from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";

interface BubbleCareLogoProps {
  size?: "sm" | "md" | "lg";
  includeText?: boolean;
}

const BubbleCareLogo: React.FC<BubbleCareLogoProps> = ({ 
  size = "md", 
  includeText = true 
}) => {
  const sizeMap = {
    sm: {
      container: "h-8 w-8",
      icon: 16,
      font: "text-lg",
      spacing: "space-x-1.5"
    },
    md: {
      container: "h-10 w-10",
      icon: 20,
      font: "text-xl",
      spacing: "space-x-2"
    },
    lg: {
      container: "h-12 w-12",
      icon: 24,
      font: "text-2xl",
      spacing: "space-x-3"
    }
  };

  const selected = sizeMap[size];

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={`flex items-center ${selected.spacing}`}
    >
      <div className={`${selected.container} rounded-full bg-gradient-to-br from-blue-300 to-blue-500 flex items-center justify-center shadow-md relative overflow-hidden`}>
        {/* Main bubble */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-300 to-blue-500 opacity-80"></div>
        
        {/* Inner bubble circles */}
        <div className="absolute top-1/4 left-1/4 w-1/4 h-1/4 rounded-full bg-white/30"></div>
        <div className="absolute bottom-1/4 right-1/4 w-1/5 h-1/5 rounded-full bg-white/20"></div>
        
        {/* Heart icon */}
        <Heart 
          className="text-white relative z-10" 
          size={selected.icon} 
          fill="white" 
          strokeWidth={2.5} 
        />
      </div>
      
      {includeText && (
        <span className={`font-semibold ${selected.font} tracking-tight text-tech-800 bg-gradient-to-r from-blue-500 to-blue-700 bg-clip-text text-transparent`}>
          BubbleCare
        </span>
      )}
    </motion.div>
  );
};

export default BubbleCareLogo;
